import type { FaireProductEntity } from "../../entity_types/product";

export const p_ju7bbu6gtd: FaireProductEntity = {
  token: "p_ju7bbu6gtd",
  type: "product",
  name: "Men's Psychedelic Starry Shrooms Mid Crew Socks",
  brandToken: "b_5xdelgfsdc",
  brandName: "Gypsy Rose",
  imageUrl:
    "https://cdn.faire.com/fastly/f0c0f3e6badfbd38909cb77e851334363733bcaf6be3a03894663d9f5e6a58bf.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d97cf3f65819b0480911472acd4aa01227839cabc7e9061b00e6e435a5d9a854.png",
  ],
  priceDollars: 7,
  description:
    "Men's Psychedelic Starry Shrooms Mid Crew Socks\n\nWell, these Shrooms Socks are perfect for your next trip to a festival! Make your feet a little more fun with a pair of these psychedelic socks.\n\nThis pair of mid-calf crew length novelty socks come in one size that fits most men's feet. Made of 65% Combed Cotton, 32% Nylon, 3% Spandex.\n\nWe have the same design also available in a smaller women's size: SKU #99632\n\n• Style: Crew length sock.\n• Size: Fits men's U.S. shoe size 8 - 13.\n\n𝐌𝐚𝐭𝐞𝐫𝐢𝐚𝐥:\n• 65% Combed Cotton\n• 32% Nylon\n• 3% Spandex\n\n• Care: Machine wash cold with no bleach and hang to dry.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-05T00:27:24.007Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
